import { Modal } from '@eika/modal';
import React, { FC } from 'react';
import { ModalDialogProps } from '@eika/modal/src/ModalDialogTypes';
import { useTranslate } from '../../../../hooks/useTranslate';

export const CostExplanationModal: FC<ModalDialogProps> = ({ onClose, open }) => {
    const translate = useTranslate();

    return (
        <Modal onClose={onClose} open={open} className='explanation-modal'>
            <>
                <div className="paragraph">
                    <h2 className="title">{translate('costExplanationModalTitle')}</h2>
                    <div>{translate('costExplanationModalSubtitle')}</div>
                </div>
                <div className="paragraph">
                    <h3 className='subtitle'>{translate('pensionCurrentEmployer')}</h3>
                    <div>{translate('pensionCurrentEmployerDescription')}</div>
                </div>
                <div className="paragraph">
                    <h3 className='subtitle'>{translate('pensionPreviousEmployer')}</h3>
                    <div>{translate('pensionPreviousEmployerDescription')}</div>
                </div>
            </>
        </Modal>
    );
};
